import { Injectable } from '@angular/core';

import {
    CanActivate,
    Router,
    UrlTree
} from '@angular/router';

import { Observable } from 'rxjs';

import {
    map,
    take
} from 'rxjs/operators';

import { JwtService } from '../services/jwt.service';

@Injectable({
    providedIn: 'root'
})
export class GuestGuard implements CanActivate {

    constructor(
        private jwtService: JwtService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> {

        return this.jwtService.currentJwtPayload$.pipe(

            take(1),

            map(payload => {

                if (
                    payload &&
                    !this.jwtService.isExpired(payload)
                ) {
                    return this.router.createUrlTree(['/']);
                }

                return true;
            })
        );
    }
}